import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateSmartCullUserRequest,
  SmartCullUserItem,
  PagedSmartCullUsersResponse,
  UpdateSmartCullUserRequest,
  ApiResponse
} from '../models/smart-cull-user.models';
import { SmartCullApiService } from './smart-cull-api.service';

@Injectable({
  providedIn: 'root'
})
export class SmartCullService {
  private readonly smartCullApiService = inject(SmartCullApiService);

  getSmartCullUsers(
    pageNumber: number,
    pageSize: number,
    searchTerm: string,
    isActive?: boolean
  ): Observable<ApiResponse<PagedSmartCullUsersResponse>> {
    return this.smartCullApiService.getSmartCullUsers(pageNumber, pageSize, searchTerm, isActive);
  }

  createSmartCullUser(
    payload: CreateSmartCullUserRequest
  ): Observable<ApiResponse<any>> {
    return this.smartCullApiService.createSmartCullUser(payload);
  }

  updateSmartCullUser(
    userId: number,
    payload: UpdateSmartCullUserRequest
  ): Observable<ApiResponse<any>> {
    return this.smartCullApiService.updateSmartCullUser(userId, payload);
  }

  deleteSmartCullUser(userId: number): Observable<ApiResponse<string>> {
    return this.smartCullApiService.deleteSmartCullUser(userId);
  }

  resetSmartCullUserPassword(userId: number): Observable<ApiResponse<string>> {
    return this.smartCullApiService.resetSmartCullUserPassword(userId);
  }
}